import { MoveableBookFeature } from '../../models/moveable-book-feature';
import { PageDrawing } from '../../models/page-drawing';

export class EditMoveableBookFeatureEvent {

    moveableBookFeature: MoveableBookFeature | PageDrawing;

}
